import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import 'react-phone-input-2/lib/style.css';
import { useDispatch } from "react-redux";
import { getOneUserAnalytics, userApproveReject, userReject } from "../../Redux/Slices/userAnalyticsSlice";
import { Image } from 'primereact/image';
import PhoneInput from 'react-phone-input-2';
import toast from "react-hot-toast";

const EditNotification = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(false);


    const initialValues = {
        profileImage: null,
        મુખ્ય_સભ્યની_અટક: '',
        મુખ્ય_સભ્યનું_નામ: '',
        મુખ્ય_સભ્યના_પિતા_નું_નામ: '',
        સભ્યનું_ગામનું_નામ: '',
        ઈમેલ: '',
        મોબાઈલ_નંબર: '',
        રહેઠાણનું_હાલનું_સરનામું: '',
        તમારા_ગામ_પ્રતિનિધિ_પસંદ_કરો: '',
        ધંધો_વ્યવસાય: ''
    };

    const fetchUserData = async () => {
        if (id) {
            const payload = { userId: id };
            try {
                const res = await dispatch(getOneUserAnalytics(payload)).unwrap();
                if (res.IsSuccess) {
                    setAllData(res?.Data);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    }

    const acceptRequest = async (userid) => {
        try {
            setLoading(true);
            await dispatch(userApproveReject({
                userId: userid || ""
            })).unwrap();
            // await fetchUserData();
            setLoading(false);
            navigate("/users-analytics");
        } catch (error) {
            setLoading(false);
            console.log("error :>> ", error);
        }
    }

    const rejectRequest = async (userid) => {
        try {
            setLoading(true);
            await dispatch(userReject({
                userId: userid || ""
            })).unwrap();
            await fetchUserData();
            setLoading(false);
            toast.success("User Remove Successfully");
            navigate(-1);
        } catch (error) {
            setLoading(false);
            console.log("error :>> ", error);
        }
    }

    useEffect(() => {
        fetchUserData();
    }, [id])

    return (
        <>
            <div className="bg-gray-50">
                <div className=" mx-aut0">
                    <div className="bg-white rounded-lg shadow p-9">
                        <div className="py-2 lg:py-4 flex flex-wrap items-center">
                            <button
                                onClick={() => navigate(-1)}
                                className="flex items-center text-gray_2"
                            >
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                Back
                            </button>
                        </div>
                        <div className="flex items-center space-x-4 pb-6">
                            <div className="flex-shrink-0">
                                {allData?.profile_pic ? (
                                    <img
                                        className="h-16 w-16 rounded-full object-cover"
                                        src={allData?.profile_pic}
                                        alt="Profile"
                                    />
                                ) : (
                                    <div className="h-16 w-16 rounded-full bg-gray-200 flex items-center justify-center text-xs text-gray-500 border border-gray-300">
                                        No Image
                                    </div>
                                )}
                            </div>

                            <div className="flex-1">
                                <h2 className="text-24 font-semibold text-text_1">
                                    {allData?.surname} {allData?.name} {allData?.fathername}
                                    <span className="text-14 text-green bg-[#E7FAF0] rounded-lg py-2 px-4 ml-5">{allData?.village?.gujarati_name}</span>
                                </h2>
                                <p className="text-sm text-gray-500">{allData?.countryCode}{allData?.mobile}</p>
                            </div>

                            <div className="flex space-x-3">
                                <button
                                    onClick={() => acceptRequest(allData?._id)}
                                    className="btn"
                                >
                                    Accept
                                </button>
                                <button
                                    onClick={() => rejectRequest(allData?._id)}
                                    className="px-4 py-2 bg-red hover:bg-white hover:text-red border hover:border-red text-white font-medium rounded-md anim"
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                        <div className="shadow-custom_shadow rounded-[20px] p-9">
                            {/* <h2 className="text-18 font-semibold text-gray_2 border-b border-gray_2 pb-6">emilia isobel euphemia rose clarke</h2> */}
                            <Formik
                                initialValues={initialValues}
                            >
                                {({ isSubmitting, setFieldValue }) => (
                                    <Form className=''>
                                        <div className="flex flex-wrap -mx-3">
                                            <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    મુખ્ય સભ્યની અટક
                                                </label>
                                                <Field
                                                    name="મુખ્ય_સભ્યની_અટક"
                                                    value={allData?.surname}
                                                    className="w-full p-2 border border-gray-300 rounded-md placeholder:text-14"
                                                    placeholder='મુખ્ય સભ્યની અટક'
                                                    disabled
                                                />
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    મુખ્ય સભ્યનું નામ
                                                </label>
                                                <Field
                                                    name="મુખ્ય_સભ્યનું_નામ"
                                                    value={allData?.name}
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='મુખ્ય સભ્યનું નામ*'
                                                    disabled
                                                />
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 sm:px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    મુખ્ય સભ્યના પિતા નું નામ
                                                </label>
                                                <Field
                                                    name="મુખ્ય_સભ્યના_પિતા_નું_નામ"
                                                    value={allData?.fathername}
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='મુખ્ય સભ્યના પિતા નું નામ'
                                                    disabled
                                                />
                                            </div>
                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    સભ્યના ગામનું નામ
                                                </label>
                                                <Field
                                                    name="સભ્યનું_ગામનું_નામ"
                                                    value={allData?.village?.gujarati_name}
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder="સભ્યના ગામનું નામ"
                                                    disabled
                                                />
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    ઈમેલ
                                                </label>
                                                <Field
                                                    name="ઈમેલ"
                                                    value={allData?.email}
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder="ઈમેલ"
                                                    disabled
                                                />
                                            </div>

                                            <div className="w-full md:w-1/2 lg:w-1/3 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    મોબાઈલ નંબર
                                                </label>
                                                <div className='flag_drop input_phone'>
                                                    <PhoneInput
                                                        country={'in'}
                                                        value={allData?.countryCode + "" + allData?.mobile}
                                                        onChange={phone => setFieldValue('મોબાઈલ_નંબર', phone)}
                                                        inputClass="w-full p-2 border border-gray-300 rounded-md"
                                                        placeholder='મોબાઈલ નંબર'
                                                        disabled
                                                    />
                                                </div>
                                            </div>

                                            <div className="w-full md:w-1/2 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    રહેઠાણનું હાલનું સરનામું
                                                </label>
                                                <Field
                                                    name="રહેઠાણનું_હાલનું_સરનામું"
                                                    value={allData?.address}
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='રહેઠાણનું હાલનું સરનામું'
                                                    disabled
                                                />
                                            </div>

                                            <div className="w-full md:w-1/2 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    ધંધો - વ્યવસાય
                                                </label>
                                                <Field
                                                    name=" ધંધો_વ્યવસાય"
                                                    value={allData?.business?.gujarati_name}
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='ધંધો - વ્યવસાય'
                                                    disabled
                                                />
                                            </div>

                                            {/* <div className="w-full md:w-1/2 px-3 mb-6">
                                                <label className="block text-sm font-medium text-text_1 mb-1">
                                                    તમારા ગામ પ્રતિનિધિ પસંદ કરો
                                                </label>
                                                <Field
                                                    name="તમે_પરિણીત_છો_કે_નહીં"
                                                    className="w-full p-2 border border-gray-300 rounded-md"
                                                    placeholder='તમારા ગામ પ્રતિનિધિ પસંદ કરો'
                                                    disabled
                                                />
                                            </div> */}

                                            <div className="p-3 relative">
                                                <label className="block text-sm font-medium text-text_1 mb-1 cursor-pointer">
                                                    આધાર કાર્ડનો આગળનો ફોટો
                                                </label>
                                                <div className="input w-[300px] h-40 border-dashed border border-primary flex items-center justify-center cursor-pointer">
                                                    {(Array.isArray(allData?.aadharcard) ? allData?.aadharcard[0] : allData?.aadharcard) ? (
                                                        <Image
                                                            src={Array.isArray(allData?.aadharcard) ? allData?.aadharcard[0] : allData?.aadharcard}
                                                            alt="Front Side"
                                                            className="w-full h-full overflow-hidden object-cover"
                                                            preview={true}
                                                        />
                                                    ) : (
                                                        <>
                                                            <span className="icon-export text-18 2xl:text-[20px] text-b1 inline-block"></span>
                                                            <span className="inline-block text-14 2xl:text-16 text-b1">
                                                                No Image Available
                                                            </span>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="p-3 relative">
                                                <label className="block text-sm font-medium text-text_1 mb-1 cursor-pointer">
                                                    આધાર કાર્ડનો પાછળનો ફોટો
                                                </label>
                                                <div className="input w-[300px] h-40 border-dashed border border-primary flex items-center justify-center cursor-pointer">
                                                    {Array.isArray(allData?.aadharcard) && allData?.aadharcard[1] ? (
                                                        <Image
                                                            src={allData?.aadharcard[1]}
                                                            alt="Back Side"
                                                            className="w-full h-full overflow-hidden object-cover"
                                                            preview={true}
                                                        />
                                                    ) : (
                                                        <>
                                                            <span className="icon-export text-18 2xl:text-[20px] text-b1 inline-block"></span>
                                                            <span className="inline-block text-14 2xl:text-16 text-b1">
                                                                No Image Available
                                                            </span>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditNotification;
